/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierStarterJupyterEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_STARTER_JUPYTER_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierStarterJupyterEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierStarterJupyterEnabledSettingParser.decode(input).map(res => new TierStarterJupyterEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierStarterJupyterEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierStarterJupyterEnabledSettingParser.encode(data);
    }
    static schema() {
        return TierStarterJupyterEnabledSettingParser.schema();
    }
}
